import type { Invoice } from '../types'

type Props = {
	invoice: Invoice
}

const AdditionalInformation = ({ invoice }: Props) => {
	console.log(invoice)
	return <p>Lisätietoja: </p>
}

export default AdditionalInformation
